import React, { useEffect, useState } from "react";
import { Section } from "../pages/Collection";
import collectionBaner from "../assets/images/collection/collection-baner.jpg";
import { Box, Container, Divider, Pagination, Typography } from "@mui/material";
import ClothingFilter from "../components/ClothingFilter";
import prod1 from "../assets/images/products/prod1.webp";
import prod1_2 from "../assets/images/products/prod1_2.webp";
import Product from "../components/Product";
import http from "../HttpAxios";
import config from "../config.json";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useGetProductsInCollectionQuery } from "../services/queries";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ProductSkelton from "../components/ProductSkeltoon";
import { Helmet } from "react-helmet";
const Clothing = () => {
  const { collection } = useParams();
  const productsQuery = useGetProductsInCollectionQuery(collection);
  // const products = [
  //   {
  //     id: 1,
  //     details:
  //       "Design inspiration lorem ipsum dolor sit amet, consectetuer adipiscing elit. Morbi commodo, ipsum sed pharetra gravida, orci magna rhoncus neque, id pulvinar odio lorem non turpis. Nullam sit amet enim....",
  //     img1: prod1,
  //     img2: prod1_2,
  //     title: "blue cotton leggings",
  //     oldPrice: "50,00$",
  //     newPrice: 30.0,
  //     colors: ["green", "white", "blue"],
  //     link: "",
  //     sale: "",
  //   },
  //   {
  //     id: 2,
  //     details:
  //       "Design inspiration lorem ipsum dolor sit amet, consectetuer adipiscing elit. Morbi commodo, ipsum sed pharetra gravida, orci magna rhoncus neque, id pulvinar odio lorem non turpis. Nullam sit amet enim....",
  //     img1: prod1,
  //     img2: prod1_2,
  //     title: "blue cotton leggings",
  //     oldPrice: "",
  //     newPrice: 30.0,
  //     colors: ["green", "white", "blue"],
  //     link: "",
  //     sale: "",
  //   },
  //   {
  //     id: 3,
  //     details:
  //       "Design inspiration lorem ipsum dolor sit amet, consectetuer adipiscing elit. Morbi commodo, ipsum sed pharetra gravida, orci magna rhoncus neque, id pulvinar odio lorem non turpis. Nullam sit amet enim....",
  //     img1: prod1,
  //     img2: prod1_2,
  //     title: "blue cotton leggings",
  //     oldPrice: "",
  //     newPrice: 30.0,
  //     colors: ["green", "white", "blue"],
  //     link: "",
  //     sale: "",
  //   },
  // ];
  const [pageApi, setPageApi] = useState();
  const [filterData, setFilterData] = useState();
  const [productGridDisplay, setProductGridDisplay] = useState(2);
  const filterdata = useSelector((state) => state.Filter);
  const productGridDisplaySelector = useSelector(
    (state) => state.UI.productGridDisplay
  );

  useEffect(() => {
    setProductGridDisplay(productGridDisplaySelector);
  }, [productGridDisplaySelector]);

  useEffect(() => {
    if (filterdata && filterdata.size) {
      var sizes = {};
      var colors = {};
      setFilterData(filterdata);
      if (filterdata && filterdata.size) {
        sizes = Object.fromEntries(
          Object.entries(filterdata.size).filter((key) => key.includes(true))
        );
      }
      if (filterdata && filterdata.color) {
        colors = Object.fromEntries(
          Object.entries(filterdata.color).filter((key) => key.includes(true))
        );
      }
      http.get(config.clothing_filter, {
        params: {
          title: filterdata.title,
          price: filterdata.price,
          size: sizes,
          color: colors,
        },
      });
    }
  }, [filterdata]);
  useEffect(() => {
    http.get(config.cloting_page_api + "?page=" + pageApi);
  }, [pageApi]);
  return (
    <div>
      <Helmet title={collection} />
      <Section img={collectionBaner}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat,sans-serif",
            fontWeight: 600,
            color: "white",
            zIndex: 10,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          clothing
        </Typography>
      </Section>

      <Box className="clothing_Filter" sx={{ mb: 4 }}>
        <ClothingFilter />
      </Box>
      <Container
        maxWidth="lg"
        sx={{
          display: "grid",
          flexDirection: { xs: "row" },
          gap: 2,
          flexWrap: "wrap",
          justifyContent: "start",
          // gridTemplateColumns: {
          // sm: "repeat(1, minmax(0, 1fr))",
          // md: "repeat(2, minmax(0, 2fr))",
          // lg: "repeat(3, minmax(0, 3fr))",
          // },
          gridTemplateColumns: {
            xs: "repeat(1, minmax(0, 1fr))",
            md: productGridDisplay
              ? `repeat(${productGridDisplay}, minmax(0, ${productGridDisplay}fr))`
              : "repeat(3, minmax(0, 3fr))",
          },
        }}
      >
        {productsQuery.isLoading && <ProductSkelton />}
        {productsQuery.isError && (
          <h4 style={{ textAlign: "center", width: "100%" }}>
            something wrong happened...try again!
          </h4>
        )}
        {productsQuery.isSuccess &&
          productsQuery.data.data.map((prod, index) => (
            <Product
              // id={prod.id}
              // productDisplayprop={productGridDisplay}
              // key={index}
              // img1={prod.img1}
              // img2={prod.img2}
              // title={prod.title}
              // oldPrice={prod.oldPrice}
              // newPrice={prod.newPrice}
              // colors={prod.colors}
              // link={prod.link}
              // sale={prod.sale}
              // details={prod.details}
              id={prod.id}
              productDisplayprop={productGridDisplay}
              key={index}
              img1={prod.image}
              img2={prod.image}
              title={prod.title}
              oldPrice={prod.price - (prod.price * 10) / 100}
              newPrice={prod.price}
              colors={["green", "white", "blue"]}
              link={prod.link}
              sale={prod.sale}
              details={prod.details}
            />
          ))}
      </Container>
      <Divider sx={{ width: "80%", margin: "auto", my: 4 }} />
      <Pagination
        sx={{ justifyContent: "center", display: "flex", mb: 12 }}
        count={10}
        onChange={(e, value) => setPageApi(value)}
      />
    </div>
  );
};

export default Clothing;
